import { WORKER_BASE_URL } from "./firebaseConfig";
import { getCurrentIdToken } from "./auth";

export interface RequestLocationSuccess {
  ok: true;
  requestId: string;
}

export interface RequestLocationFailure {
  ok: false;
  error: string;
}

export type RequestLocationResult = RequestLocationSuccess | RequestLocationFailure;

/**
 * Worker の POST /api/request-location を呼び出す。
 * architecture.md セクション4.1/5:
 *   - Authorization: Bearer <Firebase IDトークン> を付与する
 *   - レスポンスは { ok: true, requestId } または { ok: false, error }
 */
export async function requestLocation(): Promise<RequestLocationResult> {
  let idToken: string;
  try {
    idToken = await getCurrentIdToken();
  } catch {
    return { ok: false, error: "not_authenticated" };
  }

  try {
    const res = await fetch(`${WORKER_BASE_URL}/api/request-location`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    });

    let body: unknown;
    try {
      body = await res.json();
    } catch {
      body = null;
    }

    if (
      body &&
      typeof body === "object" &&
      "ok" in body &&
      (body as { ok: unknown }).ok === true &&
      "requestId" in body
    ) {
      const requestId = (body as { requestId: unknown }).requestId;
      if (typeof requestId === "string") {
        return { ok: true, requestId };
      }
    }

    if (
      body &&
      typeof body === "object" &&
      "error" in body &&
      typeof (body as { error: unknown }).error === "string"
    ) {
      return { ok: false, error: (body as { error: string }).error };
    }

    return { ok: false, error: `unexpected_response_${res.status}` };
  } catch {
    return { ok: false, error: "network_error" };
  }
}
